<h2 class="what-is">What is the problem?</h2>

<p class="problemSearchInfo">
    Select from the list below or search by keyword.
</p>
<div class="selectionContainer">
    <div class="problemSelection">
        <div class="problemSearch">
            <div class="searchContainer">
                <div class="searchField">
                    <input type="text" [(ngModel)]="searchFieldText" id="problemSearchField" tabindex="1"
                        name="problemSearchField" placeholder='Search by keyword' maxlength="300"
                        (input)="updateSearchFieldFilter()" (touchend)="handleToggleSliderWindow($event)">
                    
                    <div class="searchIcon">
                        <svg version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="27px" height="25px"
                            xmlns="http://www.w3.org/2000/svg">
                            <g transform="matrix(1 0 0 1 -39 -422 )">
                                <path
                                    d="M 25.924383544921874 24.771093750000002  C 26.2353515625 24.4677734375  26.2353515625 23.9697265625  25.92388916015625 23.6669921875  L 18.9283447265625 16.7578125  C 20.4708251953125 14.98046875  21.36566162109375 12.6806640625  21.36566162109375 10.15625  C 21.36566162109375 4.5458984375  16.761456298828126 0  11.082458496093752 0  C 5.403460693359376 0  0.8437401123046876 4.547363281249999  0.8437401123046876 10.15625  C 0.8437401123046876 15.76513671875  5.447460937500001 20.3125  11.08245849609375 20.3125  C 13.63743896484375 20.3125  15.969451904296875 19.38671875  17.766540527343746 17.86376953125  L 24.762084960937496 24.77294921875  C 24.9598388671875 24.921875  25.16253662109375 25  25.365234375 25  C 25.56793212890625 25  25.770036621093748 24.923730468749998  25.924383544921874 24.771093750000002  Z M 19.828125 10.15625  C 19.828125 14.936523437499998  15.9224853515625 18.75  11.126953125 18.75  C 6.28692626953125 18.75  2.42578125 14.892578125  2.42578125 10.15625  C 2.42578125 5.419921875  6.28692626953125 1.5625  11.126953125 1.5625  C 15.96697998046875 1.5625  19.828125 5.3759765625  19.828125 10.15625  Z "
                                    fill-rule="nonzero" fill="#333333" stroke="none" transform="matrix(1 0 0 1 39 422 )" />
                            </g>
                        </svg>
                    </div>
                </div>
            </div>
            <p [class.showCounter]="searchFieldText.length > 0 && filteredProblemsItemCount !== 0">Displaying
                {{filteredProblemsItemCount}} results</p>
            <ng-container *ngIf="searchFieldText.length > 0 && filteredProblemsItemCount === 0">
                <div class="noSearchResults">
                    <span>No search results</span>
                </div>
            </ng-container>
        </div>

        <div class="categorySelection">
            <ngb-accordion [closeOthers]="true" #accordion>
                <ng-container *ngFor="let menuLevel1 of problemMenuItems; let tabIdx = index">
                    <ngb-panel cardClass="categorySelectionOptions"
                        id="{{generateId(menuLevel1.shouldExpandDropdown, menuLevel1.menuHead)}}">
                        <ng-template ngbPanelTitle>
                            <div id="{{getMenuId(menuLevel1.menuHead)}}" (click)="onLevelOneMenuItemSelect(menuLevel1)"
                                (mousedown)="handleMouseDown($event)" class="menuLevel1 menuItemElement"
                                [class.selected]="menuLevel1.selected" (keyup)="handleKeypress($event, menuLevel1)">

                                <div class="categoryMenuInfo">
                                    <div class="categoryIcon" [innerHTML]="getIcon(menuLevel1.menuHead)"></div>
                                    <div class="categoryText" [innerHTML]="generateMenuTextHTML(menuLevel1.menuHead)">
                                    </div>

                                </div>
                                <div class="categoryMoreOptions" *ngIf="menuLevel1.menuItem === null">
                                    <i class="fas fa-plus"></i>
                                    <i class="fas fa-minus"></i>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template ngbPanelContent>
                            <div *ngIf="menuLevel1.menuItem === null" class="">
                                <ngb-accordion #accordion2 class="level2">
                                    <ngb-panel *ngFor="let menuLevel2 of menuLevel1.subMenus"
                                        [cardClass]="menuLevel2.subMenus.length === 0 ? 'noChild': ''"
                                        id="{{generateId(menuLevel2.shouldExpandDropdown,menuLevel1.menuHead, menuLevel2.menuHead)}}">
                                        <ng-template ngbPanelTitle>
                                            <div id="{{getMenuId(menuLevel1.menuHead, menuLevel2.menuHead)}}"
                                                (mousedown)="handleMouseDown($event)"
                                                (click)="onLevelTwoMenuItemSelect(menuLevel1, menuLevel2)"
                                                (keyup)="handleKeypress($event, menuLevel1, menuLevel2)"
                                                class="menuItemElement" [class.selected]="menuLevel2.selected === true">

                                                <div class="levelTwoMenuInfo"
                                                    [innerHTML]="generateMenuTextHTML(menuLevel2.menuHead)"></div>
                                                <div class="categoryMoreOptions" *ngIf="menuLevel2.menuItem === null">
                                                    <i class="fas fa-plus"></i>
                                                    <i class="fas fa-minus"></i>
                                                </div>
                                            </div>
                                        </ng-template>

                                        <ng-template ngbPanelContent>
                                            <div *ngFor="let menuLevel3 of menuLevel2.subMenus"
                                                [class.noChild]="menuLevel2.subMenus.length === 0" class="level3">
                                                <button (click)="onLevelThreeMenuItemSelect(menuLevel3)"
                                                    (keyup)="handleKeypress($event, menuLevel1, menuLevel2, menuLevel3)"
                                                    class="menuItemElement accordion-button"
                                                    [class.selected]="menuLevel3.selected === true"
                                                    (mousedown)="handleMouseDown($event)"
                                                    id="{{getMenuId(menuLevel1.menuHead, menuLevel2.menuHead, menuLevel3.menuHead)}}">
                                                    <!-- tabindex="{{getTabIndex(menuLevel1, menuLevel2, menuLevel3)}}" -->
                                                    <div class="levelThreeMenuInfo"
                                                        [innerHTML]="generateMenuTextHTML(menuLevel3.menuHead)">
                                                    </div>
                                                </button>
                                            </div>
                                        </ng-template>

                                    </ngb-panel>
                                </ngb-accordion>
                            </div>
                        </ng-template>
                    </ngb-panel>
                </ng-container>
            </ngb-accordion>
        </div>
    </div>

    <div class="commonSearches" *ngIf="!isMobile.any()">
        <div class="commonSearchesTitle">Common searches</div>
        <p *ngFor="let searchTerm of commonSearches" class="commonSearchesItem"
            (click)="handleCommonSearch(searchTerm)">{{searchTerm}}</p>
    </div>
</div>

<div class="slideWindow close" id="slideWindow">
    <div class="mobileInputContainer">
        <div class="exitFilterIcon" (touchend)="handleToggleSliderWindow($event)">
            <i class="fas fa-arrow-left"></i>
        </div>

        <div class="mobileSearchField">
            <input type="text" [(ngModel)]="searchFieldText" id="mobileSearchField" name="mobileSearchField"
                placeholder='Search by keyword' (input)="updateSearchFieldFilter()" maxlength="300" #mobileSearchField>
        </div>

        <ng-container *ngIf="searchFieldText.length > 0">
            <div class="clearTextIcon" (click)="handleClearSearchFieldText()">
                <i class="far fa-times-circle"></i>
            </div>
        </ng-container>
    </div>

    <ng-container *ngIf="searchFieldText.length === 0 || filteredProblemsItemCount === 0">
        <div class="commonSearchContainer">
            <ng-container *ngIf="searchFieldText.length === 0">
                <div class="title">Common searches</div>
            </ng-container>

            <ng-container *ngIf="searchFieldText.length !== 0">
                <div class="title">Suggested options</div>
            </ng-container>

            <ng-container *ngFor="let searchItem of commonSearches">
                <div class="commonSearchItem" (click)="handleCommonSearch(searchItem)">
                    {{searchItem}}
                </div>
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ngIf="searchFieldText.length > 0">
        <div class="mobileInputFilterResults">
            <div class="categorySelection">

                <ng-container *ngIf="searchFieldText.length > 0 && filteredProblemsItemCount === 0">
                    <div class="noSearchResults">
                        <span>No search results</span>
                    </div>
                </ng-container>
                <ngb-accordion [closeOthers]="true" #accordionMobile>
                    <ng-container *ngFor="let menuLevel1 of problemMenuItems; let tabIdx = index">
                        <ngb-panel id="{{generateId(menuLevel1.shouldExpandDropdown, menuLevel1.menuHead)}}">
                            <ng-template ngbPanelTitle>
                                <div id="{{getMenuId(menuLevel1.menuHead)}}"
                                    (click)="onLevelOneMenuItemSelect(menuLevel1)" (mousedown)="handleMouseDown($event)"
                                    class="menuLevel1 menuItemElement" [class.selected]="menuLevel1.selected"
                                    (keyup)="handleKeypress($event, menuLevel1)">
                                    <div class="categoryMenuInfo">
                                        <div class="categoryIcon" [innerHTML]="getIcon(menuLevel1.menuHead)"></div>
                                        <div class="categoryText"
                                            [innerHTML]="generateMenuTextHTML(menuLevel1.menuHead)"></div>

                                    </div>
                                    <div class="categoryMoreOptions" *ngIf="menuLevel1.menuItem === null">
                                        <i class="fas fa-plus"></i>
                                        <i class="fas fa-minus"></i>
                                    </div>
                                </div>
                            </ng-template>
                            <ng-template ngbPanelContent>
                                <div *ngIf="menuLevel1.menuItem === null" class="">
                                    <ngb-accordion #accordionMobile2 class="level2">

                                        <ngb-panel *ngFor="let menuLevel2 of menuLevel1.subMenus"
                                            [cardClass]="menuLevel2.subMenus.length === 0 ? 'noChild': ''"
                                            id="{{generateId(menuLevel2.shouldExpandDropdown, menuLevel1.menuHead, menuLevel2.menuHead)}}">
                                            <ng-template ngbPanelTitle>
                                                <div id="{{getMenuId(menuLevel1.menuHead, menuLevel2.menuHead)}}"
                                                    (mousedown)="handleMouseDown($event)"
                                                    (click)="onLevelTwoMenuItemSelect(menuLevel1, menuLevel2)"
                                                    (keyup)="handleKeypress($event, menuLevel1, menuLevel2)"
                                                    class="menuItemElement"
                                                    [class.selected]="menuLevel2.selected === true">
                                                    <div class="levelTwoMenuInfo"
                                                        [innerHTML]="generateMenuTextHTML(menuLevel2.menuHead)"></div>
                                                    <div class="categoryMoreOptions"
                                                        *ngIf="menuLevel2.menuItem === null">
                                                        <i class="fas fa-plus"></i>
                                                        <i class="fas fa-minus"></i>
                                                    </div>
                                                </div>
                                            </ng-template>

                                            <ng-template ngbPanelContent>
                                                <div *ngFor="let menuLevel3 of menuLevel2.subMenus"
                                                    [class.noChild]="menuLevel2.subMenus.length === 0" class="level3">
                                                    <button (click)="onLevelThreeMenuItemSelect(menuLevel3)"
                                                        (keyup)="handleKeypress($event, menuLevel1, menuLevel2, menuLevel3)"
                                                        class="menuItemElement accordion-button"
                                                        [class.selected]="menuLevel3.selected === true"
                                                        (mousedown)="handleMouseDown($event)"
                                                        id="{{getMenuId(menuLevel1.menuHead, menuLevel2.menuHead, menuLevel3.menuHead)}}">
                                                        <div class="levelThreeMenuInfo"
                                                            [innerHTML]="generateMenuTextHTML(menuLevel3.menuHead)">
                                                        </div>
                                                    </button>
                                                </div>
                                            </ng-template>

                                        </ngb-panel>
                                    </ngb-accordion>
                                </div>
                            </ng-template>
                        </ngb-panel>
                    </ng-container>
                </ngb-accordion>

                <!-- <ng-container *ngFor="let menuLevel1 of problemMenuItems">
                    <ul class="categorySelectionOptions mobileCategoryMenu">
                        <li id="{{getMenuId(menuLevel1.menuHead)}}" (click)="onLevelOneMenuItemSelect(menuLevel1)"
                            class="menuLevel1 menuItemElement" [class.selected]="menuLevel1.selected"
                            (keyup)="handleKeypress($event, menuLevel1)" (mousedown)="handleMouseDown($event)">

                            <div class="categoryMenuInfo">
                                <div class="categoryIcon" [innerHTML]="getIcon(menuLevel1.menuHead)"></div>
                                <div class="categoryText mobileCategoryMenuText"
                                    [innerHTML]="generateMenuTextHTML(menuLevel1.menuHead)"></div>
                            </div>

                            <ng-container *ngIf="menuLevel1.menuItem === null">
                                <div class="categoryMoreOptions" [class.minusIcon]="menuLevelOneToggle(menuLevel1)">
                                    <i class="fas fa-plus"></i>
                                    <i class="fas fa-minus"></i>
                                </div>{{level1Selected}}
                            </ng-container>
                        </li>

                        <ng-container *ngIf="menuLevel1.menuItem === null">
                            <li class="menuLevel2" [class.displayLevel]="menuLevelOneToggle(menuLevel1)">

                                <ng-container *ngFor="let menuLevel2 of menuLevel1.subMenus">
                                    <ul>
                                        <li id="{{getMenuId(menuLevel1.menuHead, menuLevel2.menuHead)}}"
                                            (click)="onLevelTwoMenuItemSelect(menuLevel1, menuLevel2)"
                                            (keyup)="handleKeypress($event, menuLevel1, menuLevel2)"
                                            (mousedown)="handleMouseDown($event)" class="menuItemElement"
                                            [class.selected]="menuLevel2.selected === true">

                                            <div class="levelTwoMenuInfo"
                                                [innerHTML]="generateMenuTextHTML(menuLevel2.menuHead)"></div>

                                            <ng-container *ngIf="menuLevel2.menuItem === null">
                                                <div class="categoryMoreOptions"
                                                    [class.minusIcon]="menuLevelTwoToggle(menuLevel2.menuHead)">
                                                    <i class="fas fa-plus"></i>
                                                    <i class="fas fa-minus"></i>
                                                </div>
                                            </ng-container>
                                        </li>

                                        <ng-container *ngIf="menuLevel2.menuItem === null">
                                            <li class="menuLevel3"
                                                [class.displayLevel]="menuLevelTwoToggle(menuLevel2.menuHead)">
                                                <ng-container *ngFor="let menuLevel3 of menuLevel2.subMenus">
                                                    <ul>
                                                        <li (click)="onLevelThreeMenuItemSelect(menuLevel3)"
                                                            (keyup)="handleKeypress($event, menuLevel1, menuLevel2, menuLevel3)"
                                                            class="menuItemElement"
                                                            [class.selected]="menuLevel3.selected === true"
                                                            (mousedown)="handleMouseDown($event)"
                                                            id="{{getMenuId(menuLevel1.menuHead, menuLevel2.menuHead, menuLevel3.menuHead)}}">

                                                            <div class="levelThreeMenuInfo"
                                                                [innerHTML]="generateMenuTextHTML(menuLevel3.menuHead)">
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </ng-container>
                                            </li>
                                        </ng-container>
                                    </ul>
                                </ng-container>
                            </li>
                        </ng-container>
                    </ul>
                </ng-container> -->
            </div>
        </div>
    </ng-container>
</div>
<!-- <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.0/dist/css/bootstrap.min.css" /> -->